import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const CComSecondaryIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M12,19.35a2,2,0,1,1,1.47-.6A2,2,0,0,1,12,19.35Zm0-9.1a8.79,8.79,0,0,1,2.95.5,9.2,9.2,0,0,1,2.53,1.36,1,1,0,0,1,.42.82,1.15,1.15,0,0,1-.36.88,1.23,1.23,0,0,1-.87.36,1.62,1.62,0,0,1-.93-.28A6.8,6.8,0,0,0,14,13a6.67,6.67,0,0,0-4,0,6.8,6.8,0,0,0-1.73.85,1.54,1.54,0,0,1-.93.27,1.28,1.28,0,0,1-.87-.37,1.23,1.23,0,0,1-.35-.88,1,1,0,0,1,.41-.82,8.92,8.92,0,0,1,2.53-1.35A8.78,8.78,0,0,1,12,10.25Zm0-5a13.78,13.78,0,0,1,4.87.85A13.46,13.46,0,0,1,21,8.53a1.19,1.19,0,0,1,.44.87,1.21,1.21,0,0,1-1.22,1.25,1.37,1.37,0,0,1-.93-.32,11.59,11.59,0,0,0-3.34-1.89A11.37,11.37,0,0,0,12,7.77a11.37,11.37,0,0,0-3.92.67,11.59,11.59,0,0,0-3.34,1.89,1.37,1.37,0,0,1-.93.32A1.19,1.19,0,0,1,3,8.53a13.46,13.46,0,0,1,4.1-2.39A13.78,13.78,0,0,1,12,5.29Z" />
    </SvgIcon>
  )
}

export default CComSecondaryIcon
